const office = {
    init() {
        office.create();
    },
    create() {
        const selectOfficeEle = $("[data-select-office-element]");
        if (!selectOfficeEle.length) return;

        selectOfficeEle.on('click', function(event) {
            event.preventDefault();
            var _this = $(this);
            var dropdownContent = _this.parents('[data-select-office]').find('[data-select-office-dropdown]');

            if(_this.parents('[data-select-office]').hasClass('on')) {
                
                _this.parents('[data-select-office]').removeClass('on');
            } else {

                _this.parents('[data-select-office]').addClass('on');
            }
            
        });

        $('body').on('click', function(event) {
            if($(event.target).parents('[data-select-office]').length == 0) {
                $("[data-select-office]").removeClass('on')
            }
        });

        $(window).scroll(function(event) {
            $("[data-select-office]").removeClass('on')
        });
    }
};

$(function() {
    office.init();
});